import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getTourStops = async tourId => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('tour_stops')
    .select(
      `
      *,
      place:places (
        id,
        name,
        address
      )
    `
    )
    .eq('tour_id', tourId)
    .order('stop_number');

  if (error) {
    throw error;
  }

  return data;
};

export const createTourStop = async stopData => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('tour_stops').insert([stopData]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateTourStop = async (id, stopData) => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('tour_stops')
    .upsert({ ...stopData, id })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteTourStop = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('tour_stops').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
